import {daUtils} from '../_utils';
import {
    IApiResponse, ILookupSearchTerm,
    ILookupUserSearchTerm,
    IMuiDataRequest,
} from "./types";
import {API_PAF_BASE_URI} from "./index";
import {merge} from "lodash";

const API_LOOKUP_USER_COMPANY_POST =`${API_PAF_BASE_URI}/lookups/user/company/`;
const API_LOOKUP_USER_LISTADMIN_POST =`${API_PAF_BASE_URI}/lookups/user/listadmin/`;
const API_LOOKUP_USER_GROUP_POST =`${API_PAF_BASE_URI}/lookups/user/group/`;
const API_LOOKUP_NAICS_POST =`${API_PAF_BASE_URI}/lookups/naics/`;

/** In-memory cache for get_user_group_lookup: key -> IApiResponse. Cleared only on page reload. */
const userGroupLookupCache: Record<string, IApiResponse> = {};
const API_LOOKUP_STATE_POST =`${API_PAF_BASE_URI}/lookups/state/`;


const get_user_customer_lookup = async (
    options: ILookupUserSearchTerm,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_LOOKUP_USER_COMPANY_POST;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_user_listadmin_lookup = async (
    options: ILookupUserSearchTerm,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_LOOKUP_USER_LISTADMIN_POST;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_user_group_lookup = async (
    options: ILookupUserSearchTerm,
    auth_token: string | undefined = undefined) => {
    const cacheKey = `user_group_${options.user_id ?? ''}_${options.search_term ?? ''}`;
    const cached = userGroupLookupCache[cacheKey];
    if (cached) {
        return cached;
    }
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_LOOKUP_USER_GROUP_POST;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp && resp.success && resp.data != null) {
            userGroupLookupCache[cacheKey] = resp;
        }
        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_naics_lookup = async (
    options: ILookupSearchTerm,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_LOOKUP_NAICS_POST;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_state_lookup = async (
    options: ILookupSearchTerm,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_LOOKUP_STATE_POST;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}


export const lookupApi = {
    get_user_customer_lookup,
    get_user_listadmin_lookup,
    get_user_group_lookup,
    get_naics_lookup,
    get_state_lookup,
};